// extracted by mini-css-extract-plugin
export var completionBody = "_mn-2";
export var completionCard = "_mn-0";
export var completionFooter = "_mn-3";
export var completionTitle = "_mn-1";